<button type="button" class="btn btn-outline-primary"
        (click)="loadVision()">Refresh
</button>&nbsp;
<table-component sortName="date" sortOrder="desc" #trainingTable [buttons]="resultsButtons"
                 (onRemove)="onRemoveLearning($event)"></table-component>
<image-select-component></image-select-component>
